export default __webpack_public_path__ + "static/media/main-characters-end-md-2x.98782d4c.jpg";